<app-admin-header *ngIf="hasAccess(['ADMIN'])"></app-admin-header>
<app-mda-header *ngIf="hasAccess(['MDA'])"></app-mda-header>

<div class="container">


    <div class="bg-white mt-5 p-4">
            <div class="row justify-content-center d-flex">
        <form class="content d-flex justify-content-between align-items-center" [formGroup]="form">

            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-12 col-xs-12 mt-3">
                <label class="mb-2">Verification Type</label>
                <select class="form-control small-option-font" formControlName="verificationType">
                    <option value="">-- Select Type--</option>
                    <option value="annualReturnCertificate">Annual Return Receipt/Certificate</option>
                    <option value="assessmentReceipt">Assessment Receipt / Certificate</option>
                    <option value="payeTcc">PAYE TCC</option>
                    <option value="paymentReceipt">Payment Receipt</option>
                    <option value="stamp_duty">Stamp Duty Certificate</option>
                    <option value="cgt">Capital Gain Tax Certificate</option>
                    <option value="tcc">Tax Clearance Certificate</option>
                    <option value="wht">Withholding Tax</option>

                </select>
            </div>

            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-12 col-xs-12 mt-3">
                <label class="mb-2">ID.</label>
                <input type="text" class="form-control small-option-font" formControlName="id" placeholder="Enter ID: #### - ##########"/>
            </div>

            <div class="col-lg-4 col-xl-4 col-md-4 col-sm-12 col-xs-12 d-flex align-items-end mt-3">
                <button type="submit" class="verify-button"
                        [disabled]="!form.valid" (click)="submit()">
                    Verify
                </button>
            </div>
        </form>
            </div>
    </div>

<!--    TCC-213654009-->

    <div *ngIf="details?.message" class="bg-white mt-5 p-4">

        <div class="d-flex justify-content-center mb-3 mt-3">
            <p style="font-weight: 900;color: #107E08;font-size: 46px;font-family: cursive">{{details?.status | uppercase}}</p>
        </div>
       <div class="d-flex justify-content-center mb-3 mt-3">
           <img style="width: 200px; height: 200px; border-radius: 50%" [src]="details?.photo" alt="user photo">
        </div>

        <tbody class="tbody">
        <tr style="margin-bottom: 10px" *ngIf="details?.assessmentType">
            <td class="details-head-l">Type:</td>
            <td class="details-head-r"><b>{{details?.assessmentType | uppercase | removeUnderscores}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.assessmentId">
            <td class="details-head-l">AIRMS ID:</td>
            <td class="details-head-r"><b>{{details?.assessmentId | uppercase}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.applicationId">
            <td class="details-head-l">Application ID:</td>
            <td class="details-head-r"><b>{{details?.applicationId | uppercase}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.receiptNo">
            <td class="details-head-l">Receipt No.:</td>
            <td class="details-head-r"><b>{{details?.receiptNo | uppercase}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.paymentChannel">
            <td class="details-head-l">Payment Channel:</td>
            <td class="details-head-r"><b>{{details?.paymentChannel | uppercase | removeUnderscores}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.assessmentYear">
            <td class="details-head-l">Assessment Year:</td>
            <td class="details-head-r"><b>{{details?.assessmentYear | uppercase}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.expiryYear">
            <td class="details-hea-l" style="color: red;">Expiry Year:</td>
            <td class="details-head-r" style="color: red;"><b>{{details?.expiryYear | uppercase}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px" *ngIf="details?.expiryDate">
            <td class="details-head-l" style="color: red;">Expiry Date:</td>
            <td class="details-head-r" style="color: red;"><b>{{details?.expiryDate | dateonly}}</b></td>
        </tr>
        <tr style="margin-bottom: 10px">
            <td class="details-head-l">Full Name:</td>
            <td class="details-head-r"><b>{{details?.fullName | titlecase}}</b></td>
        </tr>
        <tr *ngIf="details?.asin">
            <td class="details-head-l">ASIN:</td>
            <td class="details-head-r"><b>{{details?.asin | uppercase}}</b></td>
        </tr>
        <tr *ngIf="details?.email">
            <td class="details-head-l">Email:</td>
            <td class="details-head-r"><b>{{details?.email | lowercase}}</b></td>
        </tr>
        <tr *ngIf="details?.companyName">
            <td class="details-head-l">Company Name:</td>
            <td class="details-head-r"><b>{{details?.companyName | titlecase}}</b></td>
        </tr>
        <tr *ngIf="details?.description">
            <td class="details-head-l">Description:</td>
            <td *ngIf="details?.description && details?.description != 'Not Paid'" class="details-head-r"><b>{{details?.description | titlecase}}</b></td>
            <td *ngIf="details?.description && details?.description == 'Not Paid'" class="details-head-r" style="color: red;"><b>{{details?.description | titlecase}}</b></td>
        </tr>
        <tr *ngIf="details?.amount ">
            <td class="details-head-l">Amount:</td>
            <td class="details-head-r"><b>{{details?.amount | nairaCurrency}}</b></td>
        </tr>
        <tr *ngIf="details?.paymentStatus">
            <td class="details-head-l">Payment Status:</td>
            <td *ngIf="details?.paymentStatus && (details?.paymentStatus == 'PAID' || details?.paymentStatus == 'APPROVED')" class="details-head-r"><b>{{details?.paymentStatus | titlecase}}</b></td>
            <td *ngIf="details?.paymentStatus && (details?.paymentStatus != 'PAID' && details?.paymentStatus != 'APPROVED')" class="details-head-r" style="color: red;"><b>{{details?.paymentStatus | titlecase}}</b></td>
        </tr>
        <tr *ngIf="details?.approvalStatus">
            <td class="details-head-l">Approval Status:</td>
            <td *ngIf="details?.approvalStatus && (details?.approvalStatus == 'APPROVED')" class="details-head-r"><b>{{details?.approvalStatus | titlecase}}</b></td>
            <td *ngIf="details?.approvalStatus && (details?.approvalStatus != 'APPROVED')" class="details-head-r" style="color: red;"><b>{{details?.approvalStatus | titlecase}}</b></td>
        </tr>
        <tr *ngIf="details.paymentDate">
            <td class="details-head-l">Payment Date:</td>
            <td *ngIf="details.paymentDate && details.paymentDate != 'Not Paid'" class="details-head-r"><b>{{details?.paymentDate| date}}</b></td>
            <td *ngIf="details.paymentDate && details.paymentDate == 'Not Paid'" class="details-head-r" style="color: red;"><b>{{details?.paymentDate}}</b></td>
        </tr>
        <tr *ngIf="details?.dateCreated">
            <td class="details-head-l">Date Created:</td>
            <td class="details-head-r"><b>{{details?.dateCreated | uppercase}}</b></td>
        </tr>
        </tbody>


        <div *ngIf="isLoading"  class="d-flex text-center justify-content-center mt-3">
            <p class="text-muted">Loading... Please wait</p>
        </div>

        <div *ngIf="details?.message == 'Not Found!'"  class="d-flex text-center justify-content-center mt-3">
            <p class="text-danger">Not Found!</p>
        </div>

    </div>

</div>

<div style="height: 473px"></div>

<div style="position: sticky !important;bottom: 0 !important;">
    <app-footer *ngIf="hasAccess(['ADMIN'])" class="m-hidden"></app-footer>
    <app-mda-footer *ngIf="hasAccess(['MDA'])" class="m-hidden"></app-mda-footer>

</div>

